import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { AthleteDiet } from "@/features/athlete-hub/athlete-diet";
import { DIET_TABS, type DietTab } from "@/features/athlete-hub/hub-tabs";
import { localDay } from "@/features/my-diet/utils/nutrition";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/diet/")({
  loader: () => ({ crumb: m.hub_nav_diet() }),
  // Tab and day live in the URL, so a day is a link and Back steps through days and tabs.
  validateSearch: z.object({
    // "progress" was a tab here until it moved to My progress; old links still land on it.
    tab: z
      .enum([...DIET_TABS, "progress"])
      .optional()
      .catch(undefined),
    day: z.iso.date().optional().catch(undefined),
  }),
  beforeLoad: ({ search }) => {
    if (search.tab === "progress") throw redirect({ to: "/progress", search: { tab: "diet" } });
  },
  component: DietPage,
});

function DietPage() {
  const { tab, day } = Route.useSearch();
  const navigate = Route.useNavigate();
  const today = localDay();
  return (
    <AthleteDiet
      tab={tab === "plans" ? "plans" : "today"}
      day={day ?? today}
      onTabChange={(next: DietTab) =>
        void navigate({ search: (prev) => ({ ...prev, tab: next === "today" ? undefined : next }), replace: true })
      }
      onDayChange={(next) => void navigate({ search: (prev) => ({ ...prev, day: next === today ? undefined : next }) })}
    />
  );
}
